module.exports = __webpack_public_path__ + "img/48.951d0d1.jpg";